// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EJ5DP","toggle":"styles_toggle__3ICP4","preview":"styles_preview__3M7An"};